import { render, staticRenderFns } from "./HistoryVariantOrder.vue?vue&type=template&id=52c64981&scoped=true"
import script from "./HistoryVariantOrder.vue?vue&type=script&lang=js"
export * from "./HistoryVariantOrder.vue?vue&type=script&lang=js"
import style0 from "./HistoryVariantOrder.vue?vue&type=style&index=0&id=52c64981&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c64981",
  null
  
)

export default component.exports